import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // If you want to link to policies

const CookieNotice = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already dismissed the notice
    const dismissed = localStorage.getItem("cookieNoticeDismissed");
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem("cookieNoticeDismissed", "true");
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-slate-700 text-white p-4 text-center z-50 shadow-lg">
      <p className="text-sm mb-2">
        Practap uses essential technologies to operate. We do not use tracking
        cookies or sell your data. Your CV and voice notes are processed in
        real-time for feedback and are not stored after your session. By
        continuing to use our service, you acknowledge our{" "}
        <Link to="/privacy-policy" className="underline hover:text-blue-300">
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link to="/terms-of-service" className="underline hover:text-blue-300">
          Terms of Use
        </Link>
        .
      </p>
      <button
        onClick={handleDismiss}
        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg text-sm"
      >
        Got it!
      </button>
    </div>
  );
};

export default CookieNotice;
